/*
 * @Author: Pension 744056574@qq.com
 * @Date: 2022-08-12 13:47:42
 * @LastEditors: Pension 744056574@qq.com
 * @LastEditTime: 2023-03-10 11:42:43
 * @FilePath: /njyx-frontend-pc/packages/share/use/useRequest.ts
 * @Description:请求数据封装
 *
 */

import axios from "axios";
import apiConfig from "../config/apiConfig";
import { Notice } from "linkd-ui";
import { warning, error, success } from "../components/notice";
import { ref, reactive, watch, unref } from "vue";
import { ElLoading } from "element-plus";
import { useRouter } from "vue-router";
import type { ComputedRef, Ref } from "vue";
import localforage from "localforage";
import md5 from "js-md5";

if (apiConfig.url.includes("test")) {
  console.log("测试接口");
} else {
  console.log("正式接口");
}
// 获取token
const getToken = () => {
  const token: string | null = localStorage.getItem("token");
  return token || "";
};

// 请求前拦截
axios.interceptors.request.use(
  (config: Record<string, any>) => {
    console.log("config", config);
    let myConfig = config;
    //处理undefined数据
    if (myConfig.data?.toString() == "[object Object]") {
      for (let key in myConfig.data) {
        if (myConfig.data[key] === undefined) {
          myConfig.data[key] = "";
        }
      }
      let tem = JSON.parse(JSON.stringify(myConfig.data));
      myConfig.data = {};
      myConfig.data = tem;
    }
    let apptimestamp = Math.round(new Date().getTime() / 1000); //到秒
    let appnonce = Math.round(apptimestamp * Math.random() + 2025); //随机数
    myConfig.headers = {
      appnonce: appnonce,
      apptimestamp: apptimestamp,
      appsigin: md5("njyxplus" + apptimestamp + appnonce),
      "Content-Type": "application/json",
      token: getToken(),
    };
    // myConfig.headers = {
    //   "Content-Type": "application/json",
    //   token: getToken(),
    // };
    // 处理formdata
    if (config.type?.toLowerCase() == "formdata") {
      myConfig.headers["Content-Type"] = "multipart/form-data";
    }
    myConfig.baseURL = config.baseUrl || apiConfig.url; // 网站接口前缀
    myConfig.method = "POST";
    if (myConfig.url.indexOf("fileUpload") != -1) {
      myConfig.timeout = 60000 * 5; //5分钟
    } else {
      myConfig.timeout = 50000;
    }

    return myConfig;
  },
  (error) => {
    // 当请求异常时做一些处理
    Notice.open("响应前拦截出错了");
    return Promise.reject(error);
  },
);
interface requestType {
  baseUrl?: string;
  api?: string;
  method?: string;
  para?: Record<any, any>;
  manual?: boolean; //手动请求,可以用promise，默认自动
  hasPager?: boolean; //是否有分页，默认没有
  autoGetDataWhenParaChange?: boolean; //数据变化的时候，是否自动请求数据，没有不自动
  preProcess?: Function; //请求过来数据之后，对数据进行预处理,，并返回需要的数据
  afterProcess?: Function; //请求完数据后的操作
  finalProcess?: Function; //请求完走的回调函数
  errorProcess?: Function; //请求错误走的回调函数
  preRequest?: Function; //请求前处理参数
  type?: string; //默认类型
  tip?: boolean; //是否有操作提示，默认没有
  noLoading?: boolean; //没有加载，默认有
  maxPageSize?: boolean; //分页size 10000，当列表使用，默认没有
  isBlob?: boolean;
  noTimeout?: boolean;
  progressCallback?: (a: string) => void;
}
export default function useRequest(option: requestType): any {
  let {
    baseUrl = "",
    api,
    method = "post",
    para = {},
    manual = false,
    hasPager = false,
    maxPageSize = false,
    noTimeout = false,
    isBlob = false,
    autoGetDataWhenParaChange = false,
    noLoading = false,
    preProcess,
    afterProcess,
    finalProcess,
    errorProcess,
    preRequest,
    type = "json",
    tip = false,
    progressCallback = () => {}, //进度条函数
  } = option;
  const isLoading = ref<boolean>(false);
  let data = ref<Record<string, any> | any[]>(); //获取的数据
  let total = ref(0); //数据总共的条数
  let pager = reactive({
    //分页数据
    pageCurrent: 1,
    pageSize: 20,
  });
  let lastRequestPara: Record<any, any> = {};
  //获取数据
  function getData(_api?: string, _para?: Record<any, any>, noLoad?: boolean) {
    const router = useRouter();
    noLoading = noLoad || noLoading;
    console.log("noLoading", noLoading);
    let setting = {
      method,
      url: _api || api,
      data: unref(_para || para),
      type,

      // `onUploadProgress` 允许为上传处理进度事件
      // 浏览器专属
      onUploadProgress: function (progressEvent: any) {
        // 处理原生进度事件
        progressCallback(progressEvent);
      },
    };
    if (type == "json") {
      setting.data = JSON.parse(JSON.stringify(setting.data));
    }
    if (maxPageSize) {
      pager.pageSize = 10000;
      hasPager = true;
    }
    if (hasPager) {
      setting.data = Object.assign({ ...pager }, setting.data);

      pager.pageCurrent = setting.data.pageCurrent;
    }

    if (preRequest) {
      let res: any = preRequest(setting.data);
      if (res) {
        setting.data = res;
      } else {
        return true;
      }
    }
    return new Promise((resolve, reject) => {
      //防止重复请求
      if (unref(para)) {
        //如果初始api在useRequest传递
        if (_para) {
          if (isLoading.value && _para == unref(para)) {
            return reject("重复请求");
          }
        } else {
          //   if (isLoading.value) {
          //     return reject("重复请求")
          //   }
        }
      } else {
        //如果初始api在getData传递
        if (isLoading.value && _para == lastRequestPara) {
          return reject("重复请求");
        }
        if (_para) {
          lastRequestPara = _para;
        }
      }
      isLoading.value = true;
      let loadingInstance: any;
      if (!noLoading) {
        loadingInstance = ElLoading.service({
          target: (document.body.querySelector("#main_top_content") as any) || (document.querySelector("#main_top_content") as any),
          fullscreen: false,
        });
      }

      axios(setting)
        .then((res) => {
          isLoading.value = false;
          if (finalProcess) {
            finalProcess();
          }

          if (isBlob) {
            if (res.data.type == "application/json") {
              reject(res);
            } else {
              const blob = new Blob([res.data]);
              const downloadElement = document.createElement("a");
              const href = window.URL.createObjectURL(blob); //创建下载的链接
              downloadElement.href = href;
              // downloadElement.download = `${filename}.xlsx` //下载后文件名
              document.body.appendChild(downloadElement);
              downloadElement.click(); //点击下载
              document.body.removeChild(downloadElement); //下载完成移除元素
              window.URL.revokeObjectURL(href); //释放掉blob对象
              resolve(res.data);
            }
          } else {
            switch (parseInt(res.data.code)) {
              case 200:
                if (!noLoading) {
                  loadingInstance.close();
                }

                // setTimeout(() => {
                if (hasPager) {
                  res.data.data.total = Number(res.data.data?.total);
                  total.value = res.data.data?.total;
                }

                if (tip) {
                  if (res.data.message) {
                    success(res.data.message);
                  }
                }

                if (type.toLowerCase() == "formdata") {
                  data.value = res.data;
                  resolve(res.data);
                  if (afterProcess) {
                    afterProcess(res.data);
                  }
                } else {
                  if (preProcess) {
                    res.data.data = preProcess(res.data.data) || res.data.data;
                  }
                  data.value = res.data.data;
                  resolve(res.data.data);
                  if (afterProcess) {
                    afterProcess(res.data.data);
                  }
                }
                // }, 700);

                // res.data.message && success(res.data.message)
                break;
              case 401:
                localStorage.removeItem("token");
                router.push({ path: "/login", query: { timeStamp: new Date().getTime() } });

              default:
                res.data.message && error(res.data.message);
                if (errorProcess) {
                  errorProcess(res.data.message);
                }

                return reject(res.data.message);
              //   reject(res.data.message)
            }
          }
        })
        .catch((err) => {
          isLoading.value = false;

          if (finalProcess) {
            finalProcess();
          }
          if (errorProcess) {
            errorProcess();
          }
          if (err && err.response) {
            const res = err.response;
            res.data.message && error(res.data.message);
            // if (err.response.status && err.response.status == "401") {
            //   localStorage.clear();
            //   location.reload();
            // }
          }
          // return reject(err)
        })
        .finally(() => {
          if (!noLoading) {
            loadingInstance.close();
          }
        });
    });
  }
  //下一页
  function nextPage() {
    if (hasPager) {
      if (Math.ceil(total.value / pager.pageSize) > pager.pageCurrent) {
        changePageIndex(pager.pageCurrent + 1);
      } else {
        console.warn("已经加载完所有分页的数据了");
      }
    }
  }
  //改变页码
  function changePageIndex(page: number = 1, isForce: boolean = false) {
    if (page !== pager.pageCurrent) {
      pager.pageCurrent = page;
      getData();
    } else if (isForce) {
      getData();
    }
  }
  //改变分页数据
  function changePageSize(s: number = 15, isForce: boolean = false) {
    if (isForce) {
      pager.pageSize = s;
      changePageIndex(1, true);
    } else {
      if (s !== pager.pageSize) {
        pager.pageSize = s;
        changePageIndex(1, true);
      }
    }
  }
  //监控参数变化，并自动发送请求
  watch(
    () => option.para,
    (prev, now) => {
      if (autoGetDataWhenParaChange === true) {
        if (hasPager) {
          changePageIndex(1, true);
        } else {
          getData();
        }
      }
    },
    { deep: true },
  );

  //如果手动请求，不自动获取数据
  if (!manual) {
    getData();
  }

  return {
    isLoading,
    data,
    pager,
    total,
    getData,
    changePageIndex,
    changePageSize,
    nextPage,
  };
}
